import Vue from 'vue'
import App from './App'
import router from './router'
// import VueAnalytics from 'vue-analytics'
// import VueGtag from 'vue-gtag'
// import VueGtm from '@gtm-support/vue2-gtm'
import store from './store/'
import VueLazyload from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'
import VueCookie from 'vue-cookie'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { Button, Tooltip, Radio, Backtop, Slider, Link, Breadcrumb, BreadcrumbItem, RadioGroup, RadioButton, Tree, Tabs, TabPane, Container, Main, Aside, Header, Collapse, CollapseItem, Tag, Image, Divider, PageHeader, Row, Col, Drawer, Carousel, CarouselItem, Menu, Submenu, MenuItem, Pagination, Checkbox, Icon, Autocomplete, Loading, Message, Notification, Steps, Step, Table, TableColumn, Input, Dialog, Select, Option } from 'element-ui'
import VueContentPlaceholders from 'vue-content-placeholders'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import lang from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'
import vueSocialSharing from 'vue-social-sharing'
import Meta from 'vue-meta'
import VueClipboard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/display.css'
Vue.use(VueClipboard)
// 设置语言
locale.use(lang)
require('es6-promise').polyfill()
Es6Promise.polyfill()
Vue.use(VueAwesomeSwiper)
Vue.use(VueContentPlaceholders)
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Meta, {
  refreshOnceOnNavigation: true
})
Vue.use(vueSocialSharing)
Vue.use(Backtop)
Vue.use(Slider)
Vue.use(Radio)
Vue.use(Link)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Tree)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Container)
Vue.use(Tag)
Vue.use(Main)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Image)
Vue.use(Divider)
Vue.use(PageHeader)
Vue.use(Row)
Vue.use(Col)
Vue.use(Drawer)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Pagination)
Vue.use(Checkbox)
Vue.use(Icon)
Vue.use(Autocomplete)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.use(infiniteScroll)
Vue.use(VueCookie)
Vue.use(VueLazyload, {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  loading: '/static/images/load.gif'
  // attempt: 1
})

// Vue.use(VueGtm, {
//   id: 'GTM-WB3RBJWX', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
//   queryParams: {
//     // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
//     gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
//     gtm_preview: 'env-4',
//     gtm_cookies_win: 'x'
//   },
//   defer: false,
//   compatibility: false,
//   nonce: '2726c7f26c',
//   enabled: true,
//   debug: true,
//   loadScript: true,
//   vueRouter: router,
//   ignoredViews: ['homepage'],
//   trackOnNextTick: false
// })

// Vue.use(VueGtag, {
//   config: {
//     id: 'G-YGM1SC33CD',
//     params: {
//       send_page_view: false
//     }
//   }
// }, router)
// Vue.use(VueAnalytics, {
//   id: 'UA-116844336-2',
//   router,
//   autoTracking: {
//     pageviewOnLoad: false
//   }
// })
Vue.config.productionTip = false
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
router.beforeEach((to, from, next) => {
  if (to.meta.metaInfo) {
    store.commit('CHANGE_META_INFO', to.meta.metaInfo)
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  metaInfo () {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          vmid: 'title',
          name: 'title',
          content: this.$store.state.metaInfo.title
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$store.state.metaInfo.keywords
        },
        {
          vmid: 'description',
          name: 'description',
          content: this.$store.state.metaInfo.description
        },
        {
          vmid: 'imageogtag',
          property: 'og:image',
          content: this.$store.state.metaInfo.icon
        },
        {
          vmid: 'urlogtag',
          property: 'og:url',
          content: this.$store.state.metaInfo.url
        },
        {
          vmid: 'titleogtag',
          property: 'og:title',
          content: this.$store.state.metaInfo.title
        },
        {
          vmid: 'descriptionogtag',
          property: 'og:description',
          content: this.$store.state.metaInfo.description
        },
        {
          vmid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary'
        },
        {
          name: 'twitter:description',
          vmid: 'twitter:description',
          content: this.$store.state.metaInfo.description
        },
        {
          name: 'twitter:title',
          vmid: 'twitter:title',
          content: this.$store.state.metaInfo.title
        },
        {
          vmid: 'twitter:image',
          name: 'twitter:image',
          content: this.$store.state.metaInfo.icon
        }
      ]
    }
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js